import { PARAGRAPH_TYPE } from './constant.js';

const paragraphHtmlToElement = ({
  children
}) => {
  return {
    type: PARAGRAPH_TYPE,
    children
  };
};

export { paragraphHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
